import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import ChatWidget from "./ChatWidget";
import WelcomeOfferBar from "./WelcomeOfferBar";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col">
      <WelcomeOfferBar />
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
      <ChatWidget />
    </div>
  );
}
